define('frontend-common-components/gettingStartedPanel/js/views/items/actionItemView',[
        'marionette',
        '../../models/actionModel',
        'hbs!../../../templates/items/actionItemTmpl',
        'underscore'
    ],
function (Marionette, ActionModel, actionItemTmpl, _) {
    'use strict';
    return Marionette.ItemView.extend({
        tagName: 'li',
        className: function () {
            var className = 'actionitem';
            
            if (this.options.model.get('enabled') === true) {
                className += ' enabled';
            }
            if (this.options.model.get('completed')  === true) {
                className += ' completed';
            }
            return className;
        },
        ui: {
            'actionItem': '.action-item-title'
        },
        
        events: {
            'click @ui.actionItem': 'onClickActionItem'
        },

        modelEvents: {
            'change': 'fieldsChanged'
        },

        fieldsChanged: function() {
            this.render();
        },
        
        template: actionItemTmpl,
        initialize: function (options) {
            this.onClickCallback = options.onClick;
        },

        isActionItemEnabled: function() {
            return this.model.get('enabled') === true;
        },

        onClickActionItem: function() {
            if(this.isActionItemEnabled()) {
                if (_.isFunction(this.onClickCallback)) {
                    this.onClickCallback();
                }
            }
        },

        enableActionItem: function() {
            this.model.set('enabled', true);
            this.addClassToRootElement('enabled');
        },

        disableActionItem: function() {
            this.model.set('enabled', false);
            this.removeClassToRootElement('enabled');
        },

        setActionItemCompleted: function() {
            this.model.set('completed', true);
            this.addClassToRootElement('completed');
        },

        setActionItemInComplete: function() {
            this.model.set('completed', false);
            this.removeClassToRootElement('completed');
        },

        addClassToRootElement: function(className) {
            this.$el.addClass(className);
        },

        removeClassToRootElement: function(className) {
            this.$el.removeClass(className);
        },

        setOptionsInModel: function(options) {
            _.each(_.keys(options), function(key) {
                this.model.set(key, options[key]);
                this.modifyRootElement(key, options[key]);
            }, this);

        },

        modifyRootElement: function(attribute, value) {
            if(attribute === 'enabled') {
                this.addOrRemoveClassFromRootElement('enabled', value);
            }else if(attribute === 'completed') {
                this.addOrRemoveClassFromRootElement('completed', value);
            }
        },

        addOrRemoveClassFromRootElement: function(className, value) {
            if(value) {
                this.addClassToRootElement(className);
            } else {
                this.removeClassToRootElement(className);
            }
        }

    });
}) ;
